import { Children, isValidElement, forwardRef } from 'react';
import './tables.css';
export function tableText(value) {
    return Children.toArray(value).map(child => isValidElement(child) ? tableText(child.props.children) : String(child)).join(' ').trim()
}
export function statusTone(status) {
    const label = String(status || '').trim().toLowerCase()
    if (['completed', 'approved', 'paid', 'active'].includes(label)) return 'success'
    if (['created', 'outstanding', 'draft'].includes(label)) return 'warning'
    if (/\boverdue$/.test(label)) return 'danger'
    if (['pending review', 'overdue', 'incomplete', 'voided'].includes(label)) return 'danger'
    return 'neutral'
}
const StatusBadge = forwardRef(function StatusBadge({ children, status, tone, className = '', ...props }, ref) {
    return <span {...props} ref={ref} className={['uiStatusBadge', 'uiStatusBadge--' + (tone || statusTone(status || tableText(children))), className].filter(Boolean).join(' ')}>{children ?? status}</span>
})
export default StatusBadge
